var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAnalyze(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 128.386,
    height: 121.999,
    viewBox: "0 0 128.386 121.999",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_13817",
    "data-name": "Group 13817",
    transform: "translate(-1012.999 -456.882)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_13719",
    "data-name": "Group 13719",
    transform: "translate(1015 456.881)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11188",
    "data-name": "Path 11188",
    d: "M263.7,545.155v120H390.083",
    transform: "translate(-263.697 -545.155)",
    fill: "none",
    stroke: "var(--secondaryColor)",
    strokeMiterlimit: 10,
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_630",
    "data-name": "Line 630",
    y1: 41.282,
    transform: "translate(35.546 50.668)",
    fill: "none",
    stroke: "var(--secondaryColor)",
    strokeMiterlimit: 10,
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_631",
    "data-name": "Line 631",
    y1: 68.352,
    transform: "translate(96.752 23.598)",
    fill: "none",
    stroke: "var(--secondaryColor)",
    strokeMiterlimit: 10,
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_632",
    "data-name": "Line 632",
    y1: 91.95,
    transform: "translate(67.652 0)",
    fill: "none",
    stroke: "var(--secondaryColor)",
    strokeMiterlimit: 10,
    strokeWidth: 4
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnalyze);
export default __webpack_public_path__ + "static/media/analyze.c9051d7e31a6f1bf13f4657aed87724a.svg";
export { ForwardRef as ReactComponent };